// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
/**
 * Immutable saved run snapshot. Other run details remain available through the existing testplanregressions API. Project appears once in the enclosing event payload.
 * @export
 * @interface WebhookTestPlanRunSnapshot
 */
export interface WebhookTestPlanRunSnapshot {
  /**
   * Run ID (the regression ID used by execution snapshots).
   * @type {number}
   * @memberof WebhookTestPlanRunSnapshot
   */
  id: number;
  /**
   *
   * @type {number}
   * @memberof WebhookTestPlanRunSnapshot
   */
  testPlan: number;
  /**
   *
   * @type {string}
   * @memberof WebhookTestPlanRunSnapshot
   */
  title?: string;
  /**
   *
   * @type {number}
   * @memberof WebhookTestPlanRunSnapshot
   */
  iteration: number;
  /**
   *
   * @type {number}
   * @memberof WebhookTestPlanRunSnapshot
   */
  status: WebhookTestPlanRunSnapshotStatusEnum;
  /**
   * Build snapshot saved on this run, after its foreign key is finalized.
   * @type {number}
   * @memberof WebhookTestPlanRunSnapshot
   */
  build?: number;
}

export function WebhookTestPlanRunSnapshotFromJSON(
  json: any
): WebhookTestPlanRunSnapshot {
  return {
    id: json["id"],
    testPlan: json["test_plan"],
    title: !exists(json, "title") ? undefined : json["title"],
    iteration: json["iteration"],
    status: json["status"],
    build: !exists(json, "build") ? undefined : json["build"],
  };
}

export function WebhookTestPlanRunSnapshotToJSON(
  value?: WebhookTestPlanRunSnapshot
): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    id: value.id,
    test_plan: value.testPlan,
    title: value.title,
    iteration: value.iteration,
    status: value.status,
    build: value.build,
  };
}

/**
 * @export
 * @enum {string}
 */
export enum WebhookTestPlanRunSnapshotStatusEnum {
  NUMBER_0 = 0,
  NUMBER_1 = 1,
  NUMBER_2 = 2,
  NUMBER_3 = 3,
  NUMBER_4 = 4,
}
